import { FormProps, FormTypes } from "../../../shared/interfaces/form";

export const projectData = (
    id?: string, 
    response?: any, 
    principalInvestigator?: any, 
    searchers?: any, 
    financiers?: any, 
    initialDate?: any, 
    finalDate?: any, 
    financier?: any, 
    companyId?: any, 
    companies?: any, 
    shouldHaveCompanies?: string, 
    timelineData?: any[]
): FormProps[] => {
    const page = window.location.hash.split('/')[1];
    const isProjectList = page === 'projeto-list';
    
    // Calcular total das movimentações baseado no timelineData
    const calculateMovements = () => {
        if (!timelineData || !Array.isArray(timelineData)) return 0;
        
        const total = timelineData.reduce((acc, item) => {
            // Verificar diferentes propriedades onde o valor pode estar
            let value: number = 0;
            let rawValue: any = item.valor || item.value || 0;
            
            // Se o valor é uma string, precisa ser processado
            if (typeof rawValue === 'string') {
                // Remove formatação e converte para número
                const cleanValue = rawValue.replace(/[^\d,-]/g, '').replace(',', '.');
                value = Number(cleanValue);
            } else {
                // Se já é número, usa diretamente (assumindo que já está em centavos)
                value = Number(rawValue) || 0;
            }
            
            return acc + value;
        }, 0);
        
        return total;
    };
    
    // Calcular saldo: valor do projeto - movimentações
    const calculateBalance = () => {
        if (!response?.valor) return 0;
        const movements = calculateMovements();
        return (response.valor - movements) / 100;
    };

    const data: FormProps[] = 
        [
            {
                typeOfField: FormTypes.INPUT,
                type: 'text',
                placeholder: 'Nome do projeto*',
                value: id? response?.name : null,
                name: 'name',
                rules: {
                    required: 'Nome do projeto é obrigatório'
                },
                width: 740,
                height: 55,
                fullWidth: window.innerWidth > 768 ? true : false,
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.SELECT,
                type: 'text',
                placeholder: 'Pesquisador Principal*',
                value: id? principalInvestigator?.id : null,
                name: 'principalInvestigatorId',
                rules: {
                    required: 'Pesquisador Principal é obrigatório'
                },
                options: {
                    placeholder: 'Pesquisador Principal',
                    data: searchers,
                    value: id? principalInvestigator?.id : null
                },
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.SELECT,
                type: 'text',
                placeholder: 'Financiador*',
                value: id? financier?.id : null,
                name: 'financierId',
                rules: {
                    required: 'Financiador é obrigatório'
                },
                options: {
                    placeholder: 'Financiador',
                    data: financiers,
                    value: id? financier?.id : null
                },
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.DATE,
                type: 'text',
                placeholder: 'Data inicial*',
                rules: {
                    required: 'Data inicial é obrigatória'
                },
                value: (initialDate? initialDate : null),
                name: 'initialDate',
                width: 350,
                height: 55,
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.DATE,
                type: 'text',
                placeholder: 'Data final*',
                value: (finalDate? finalDate : null),
                name: 'finalDate',
                width: 350,
                height: 55,
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.INPUT,
                type: 'text',
                placeholder: 'Duração em meses*',
                rules: {
                    required: 'Duração em meses é obrigatória'
                },
                value: id? response?.duration : null,
                name: 'duration',
                width: 200,
                height: 55,
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.DATE,
                type: 'text',
                placeholder: 'Data de prestação de contas parcial*',
                value: id? response?.accountabilittyDate : null,
                name: 'accountabilittyDate',
                width: 350,
                height: 55,
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.CURRENCY,
                type: 'number',
                placeholder: 'Valor do projeto',
                value: id ? response?.valor / 100 : null,
                name: 'valor',
                width: 740,
                height: 55,
                fullWidth: window.innerWidth > 768 ? true : false,
                disabled: page === 'projeto-list' || response?.isFinished ? true : false
            },
            {
                typeOfField: FormTypes.CHECKBOX,
                type: 'text',
                placeholder: 'Múltiplos repasses',
                value: id ? response?.multiplePayments : null,
                name: 'multiplePayments',
                fullWidth: window.innerWidth > 768 ? true : false,
                disabled: page === 'projeto-list' ? true : false
            }
        ];

    // Adicionar campos de movimentações e saldo apenas na visualização (project-list)
    if (isProjectList && id) {
        // Inserir movimentações após o valor do projeto (índice 8)
        data.splice(8, 0, {
            typeOfField: FormTypes.CURRENCY,
            type: 'number',
            placeholder: 'Movimentações',
            value: calculateMovements() / 100,
            name: 'movements',
            width: 740,
            height: 55,
            fullWidth: window.innerWidth > 768 ? true : false,
            disabled: true // Sempre readonly
        });

        // Inserir saldo após movimentações (índice 9)
        data.splice(9, 0, {
            typeOfField: FormTypes.CURRENCY,
            type: 'number',
            placeholder: 'Saldo',
            value: calculateBalance(),
            name: 'balance',
            width: 740,
            height: 55,
            fullWidth: window.innerWidth > 768 ? true : false,
            disabled: true // Sempre readonly
        });
    }

    // Adicionar campo de cliente se necessário
    if(shouldHaveCompanies?.toLocaleLowerCase() === 'causale') {
        data.push({
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Cliente*',
            value: companyId ? companyId : null,
            name: 'companyId',
            rules: {
                required: 'Cliente é obrigatório'
            },
            options: {
                placeholder: 'Cliente',
                data: companies,
                value: companyId ? companyId : null
            },
            disabled: page === 'projeto-list' || response?.isFinished ? true : false
        });
    }

    return data;
}  

export default projectData;